import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {ProductosSubdestinosMontosAliadosActividad} from '../_models/productos-subdestinos-montos-aliados-actividad';

@Injectable({
  providedIn: 'root'
})
export class ProductosSubdestinosMontosAliadosActividadService {
  private rutaServicio = AppSettings.rutServiciosAPL + '/api/productosSubDestinosMontosAliadosActividad';
  constructor(private httClient: HttpClient,
              private autServicio: AutenticacionService) { }

  listadoHabilitados() {
    return this.httClient.get(this.rutaServicio + '/enabled').pipe(map(res => res as ProductosSubdestinosMontosAliadosActividad[]));
  }
  /**
   * Obtiene todos los registros por  idProductoSubDestinoMontoActividad
   */
  obtenerPorId(id: string) {
    return this.httClient.get(this.rutaServicio + '/' + id).pipe(map(res => res as ProductosSubdestinosMontosAliadosActividad));
  }


  obtenerPoridSubDestinoProducto(idSubDestinoProducto: string) {
    return this.httClient.get(this.rutaServicio + '/subDestinoProducto/' + idSubDestinoProducto + '/enabled').pipe(map(res => res as ProductosSubdestinosMontosAliadosActividad[]));
  }
  listaDestinoProducto(idProductoMontoAliado: string) {
    return this.httClient.get(this.rutaServicio + '/destinoProducto/' + idProductoMontoAliado ).pipe(map(res => res as ProductosSubdestinosMontosAliadosActividad[]));
  }
  listaDestinoProductoHabilitados(idProductoMontoAliado: string) {
    return this.httClient.get(this.rutaServicio + '/destinoProducto/' + idProductoMontoAliado + '/enabled').pipe(map(res => res as ProductosSubdestinosMontosAliadosActividad[]));
  }

  listaProducto(idProductoMontoAliado: string) {
    return this.httClient.get(this.rutaServicio + '/producto/' + idProductoMontoAliado).pipe(map(res => res as ProductosSubdestinosMontosAliadosActividad[]));
  }

  listaProductoHabilitados(idProducto: string) {
    return this.httClient.get(this.rutaServicio + '/producto/' + idProducto + '/enabled').pipe(map(res => res as ProductosSubdestinosMontosAliadosActividad[]));
  }


  crearSubDestinosMontoAliados( data: ProductosSubdestinosMontosAliadosActividad ) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutaServicio, data  ).pipe( map( res => res as  ProductosSubdestinosMontosAliadosActividad) );
  }

  actualizarSubDestinosMontoAliados( data: ProductosSubdestinosMontosAliadosActividad ) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutaServicio, data ).pipe( map( res => res as ProductosSubdestinosMontosAliadosActividad ) );
  }

  bulk( data: ProductosSubdestinosMontosAliadosActividad[] ) {
    data.map( ( s: ProductosSubdestinosMontosAliadosActividad ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutaServicio + '/bulk', data ).pipe( map( res => res as ProductosSubdestinosMontosAliadosActividad[] ) );
  }
}
